import React from 'react';
import { BsWhatsapp, BsTelephoneFill, BsInstagram, BsFacebook, BsYoutube, BsLinkedin } from 'react-icons/bs';

const Footer = () => {
  return (
    <>
      <footer className="bg-dark-800 text-white/50 relative overflow-hidden border-t-4 border-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Top row: brand + nav */}
          <div className="py-14 grid lg:grid-cols-5 gap-12 items-start">
            {/* Brand — 2 cols */}
            <div className="lg:col-span-2">
              <a href="#home" className="inline-flex items-center gap-3 mb-6 group">
                <img 
                  src="/logo.png" 
                  alt="Prime Acres Logo" 
                  className="h-11 w-11 object-contain"
                />
                <div className="leading-tight">
                  <span className="text-base font-heading text-white tracking-wide">Prime Acres</span>
                  <p className="text-[9px] tracking-[0.25em] uppercase font-medium text-primary-400">Plot Your Future</p>
                </div>
              </a>
              <p className="text-[13px] leading-relaxed text-white/35 max-w-sm font-light mb-7">
                Your trusted partner in premium land investment across MahaMumbai. Over 10 years of building futures across Mumbai, Pune, and Sambhajinagar.
              </p>
              <div className="flex gap-2 mb-6">
                {[
                  { icon: <BsInstagram />, link: '#' },
                  { icon: <BsFacebook />, link: '#' },
                  { icon: <BsYoutube />, link: '#' },
                  { icon: <BsLinkedin />, link: '#' },
                ].map((s, i) => (
                  <a key={i} href={s.link} className="w-9 h-9 rounded-xl bg-white/[0.06] flex items-center justify-center text-white/40 hover:bg-primary-600 hover:text-white transition-all duration-500 text-sm">
                    {s.icon}
                  </a>
                ))}
              </div>
              <a
                href="/Brochure.pdf"
                download
                className="inline-flex items-center gap-2 border border-primary-500 text-primary-400 hover:bg-primary-600 hover:text-white rounded-full px-5 py-2.5 text-[11px] font-semibold tracking-wider uppercase transition-all duration-500"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                Download Brochure
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-medium text-[11px] tracking-[0.2em] uppercase mb-5">Navigate</h4>
              <ul className="space-y-3">
                {['MahaMumbai', 'Why Invest', 'Infrastructure', 'Services', 'About', 'Gallery', 'Contact'].map((link) => {
                  const hrefMap = { 'MahaMumbai': '#overview', 'Why Invest': '#highlights', 'Infrastructure': '#infrastructure', 'Services': '#services', 'About': '#about' };
                  return (
                    <li key={link}>
                      <a href={hrefMap[link] || `#${link.toLowerCase()}`} className="text-[12px] text-white/35 hover:text-white transition-colors duration-300 tracking-wide">
                        {link}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Investment Areas */}
            <div>
              <h4 className="text-white font-medium text-[11px] tracking-[0.2em] uppercase mb-5">Investment Areas</h4>
              <ul className="space-y-3">
                {['NAINA Plots', 'KSC New Town', 'Near NMIA Airport', 'MTHL Corridor', 'Virar-Alibaug'].map((p) => (
                  <li key={p}>
                    <a href="#contact" className="text-[12px] text-white/35 hover:text-white transition-colors duration-300 tracking-wide">
                      {p}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-medium text-[11px] tracking-[0.2em] uppercase mb-5">Reach Us</h4>
              <div className="space-y-3 text-[12px] text-white/35 font-light">
                <p>85 5001 5003</p>
                <p>theprimeacres@gmail.com</p>
                <p className="leading-relaxed">Enjoy business hub,P floor,Tower number 07,<br />Station building, Belapur CBD</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="border-t border-white/[0.06] py-6">
            <p className="text-[10px] text-white/20 leading-relaxed font-light max-w-4xl">
              <span className="text-white/30 font-medium">Disclaimer:</span> The content provided on this website is for information purposes only and does not constitute an offer to avail any service. The prices mentioned are subject to change without prior notice. Images displayed are for representation purposes only and may not reflect actual properties.
            </p>
          </div>

          {/* Bottom row */}
          <div className="border-t border-white/[0.06] py-5 pb-20 md:pb-5 flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-[11px] text-white/25 tracking-wider font-light">
              © {new Date().getFullYear()} Prime Acres Realty Pvt. Ltd.
            </p>
            <div className="flex gap-5">
              {['Privacy', 'Terms', 'Sitemap'].map((l) => (
                <a key={l} href="#home" className="text-[10px] text-white/25 hover:text-white/50 transition-colors tracking-wider uppercase">{l}</a>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile bottom bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden shadow-[0_-2px_10px_rgba(0,0,0,0.3)]" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <a href="tel:+918550015003" className="flex-1 flex items-center justify-center gap-2 bg-primary-600 text-white py-4 text-sm font-semibold">
          <BsTelephoneFill className="text-lg" /> Call Now
        </a>
        <a href="https://wa.me/918550015003" target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-green-500 text-white py-4 text-sm font-semibold">
          <BsWhatsapp className="text-lg" /> WhatsApp
        </a>
      </div>

      {/* Desktop: Call — Bottom Left */}
      <a href="tel:+918550015003" className="hidden md:flex fixed z-40 bottom-6 left-6 items-center gap-3 group">
        <div className="w-14 h-14 bg-primary-600 hover:bg-primary-700 text-white rounded-2xl flex items-center justify-center shadow-lg transition-all duration-500 hover:scale-110">
          <BsTelephoneFill className="text-xl" />
        </div>
        <span className="bg-white text-dark-700 text-xs px-3 py-1.5 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-2 group-hover:translate-x-0 shadow-lg whitespace-nowrap">
          Call Us Now
        </span>
      </a>

      {/* Desktop: WhatsApp — Bottom Right */}
      <a href="https://wa.me/918550015003" target="_blank" rel="noopener noreferrer" className="hidden md:flex fixed z-40 bottom-6 right-6 items-center gap-3 group">
        <span className="bg-white text-dark-700 text-xs px-3 py-1.5 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-2 group-hover:translate-x-0 shadow-lg whitespace-nowrap">
          Chat on WhatsApp
        </span>
        <div className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-2xl flex items-center justify-center shadow-lg transition-all duration-500 hover:scale-110">
          <BsWhatsapp className="text-2xl" />
        </div>
      </a>
    </>
  );
};

export default Footer;
